<template>
  <div>
    <b-card>
      <h4 class="mb-4">
        <strong class="mb-2">Filtros de Busca</strong>
      </h4>
      <FilterForm />
    </b-card>

    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>

    <template v-else>
      <b-table
        class="mt-2"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="users"
        :fields="fields"
      >
        <template v-slot:cell(fgActive)="row">
          <span
            :class="[
              row.value
                ? 'font-size-12 badge badge-primary'
                : 'font-size-12 badge badge-default'
            ]"
          >
            {{ row.value ? "Ativo" : "Inativo" }}
          </span>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button size="sm" :href="`${settings.route}/${row.item.id}`"
            ><i class="fe fe-edit"></i
          ></b-button>
        </template>
      </b-table>
      <b-pagination-nav
        v-if="pagination.total > 0"
        class="mt-2"
        :number-of-pages="numberOfPage"
        :link-gen="linkGen"
        use-router
      ></b-pagination-nav>
    </template>
  </div>
</template>

<script>
import FilterForm from "@/components/operations/Filter";
import { UsuarioResource } from "@/resources/Usuario.resource.js";

export default {
  components: {
    FilterForm
  },
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      users: [],
      pagination: {
        index: 1,
        size: 20,
        total: 1
      },

      sortBy: "",
      sortDesc: false,
      fgActionFilter: null,
      fgActionOptions: [
        { value: null, text: "FgActive", disabled: true },
        { value: "true", text: "True" },
        { value: "false", text: "False" }
      ],
      fields: [
        { key: "id", label: "#", sortable: true, sortDirection: "desc" },
        {
          key: "fullName",
          label: "Nome",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "document",
          label: "Documento",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "email",
          label: "E-mail",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "subordinates",
          label: "Subordinados",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "roleName",
          label: "Cargo",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "fgActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        },
        { key: "actions", label: "Editar" }
      ]
    };
  },
  async created() {
    await this.getContent();
  },
  watch: {
    "$route.query"() {
      this.getContent();
    }
  },
  computed: {
    numberOfPage() {
      return Math.ceil(this.pagination.total / this.pagination.size);
    }
  },
  methods: {
    async getContent() {
      this.loading = true;
      await UsuarioResource.getByParentUser({
        ...this.$route.query,
        idParentUser: this.$route.params.id
      })
        // await this.$api
        //   // .get(this.settings.listSubordinates, {
        //   .get(UsuarioResource.listSubordinates, {
        //     params: this.$route.query
        //   })
        .then(result => {
          this.loading = false;
          this.users = result.data.payload.items;
          this.pagination = result.data.payload.pageSettings;
        })
        .catch(e => {
          // Surpress
        });
    },
    linkGen(pageNum) {
      const queryObject = this.$route.query;
      return {
        path: this.settings.route,
        query: { ...queryObject, page: pageNum }
      };
    }
  }
};
</script>
